import { productApi } from "@/shared/core-products";
import { trackEvent } from "@/utils/firebase/analytics";

export const downloadExternalProductsExcel = async (params: string) => {
  const report = await productApi.exportExternalProductsExcel(params);
  const reportURL = URL.createObjectURL(report);
  const link = document.createElement("a");
  link.href = reportURL;
  link.download = "productos-locales.xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(reportURL);

  trackEvent("export", {
    type: "xlsx",
    module: "external_products",
  });
};
